import PropTypes from 'prop-types';
import React from 'react';
import { Button, Dropdown, MenuItem } from 'react-bootstrap';
import Icon from 'react-fa';
import SavedJobActions from '../../../actions/SavedJobActions';
import SavedJobsStore from '../../../stores/SavedJobsStore';

function wrapHandler(h) {
  return (e) => {
    h();
    e.preventDefault();
    e.stopPropagation();
  };
}

const SavedJobActionButtons = ({ savedJobId }, { router }) => {
  const onLaunchAsSelfClick = () => SavedJobActions.launch(savedJobId);

  const runAsScheduledUserJson = JSON.stringify({ runAsScheduledUser: true });
  const onLaunchAsSavedUserClick = () => SavedJobActions.launch(savedJobId,
                                                                runAsScheduledUserJson);

  const onEditModeClick = () => router.push(`/savedjobs/${savedJobId}/edit`);

  const onCloneClick = () => SavedJobActions.clone(savedJobId);

  const runAsScheduledUserMenuItem = () => {
    const userEmail = SavedJobsStore.get(savedJobId).runAsUserEmail;
    if (userEmail) {
      return (
        <MenuItem
          eventKey='saved'
          onClick={wrapHandler(onLaunchAsSavedUserClick)}
        >
          Run as scheduled user ({userEmail})
        </MenuItem>
      );
    }
    return (<MenuItem eventKey='saved-disabled' disabled>No scheduled user to run as</MenuItem>);
  };

  return (
    <span className='saved-job-button-container'>
      <Dropdown id='saved-job-runner-dropdown' className='' pullRight>
        <Dropdown.Toggle noCaret className='saved-job-button run btn-new'>
          <Icon name='play' />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <MenuItem eventKey='self' onClick={wrapHandler(onLaunchAsSelfClick)}>Run as myself</MenuItem>
          {runAsScheduledUserMenuItem()}
        </Dropdown.Menu>
      </Dropdown>

      <Button
        onClick={wrapHandler(onEditModeClick)}
        className='saved-job-button edit btn-new'
      >
        <Icon name='edit' />
      </Button>

      <Button
        onClick={wrapHandler(onCloneClick)}
        className='saved-job-button clone btn-new'
      >
        <Icon name='clone' />
      </Button>
    </span>
  );
};

SavedJobActionButtons.propTypes = {
  savedJobId: PropTypes.number,
};

SavedJobActionButtons.contextTypes = {
  router: PropTypes.object,
};

export default SavedJobActionButtons;
